import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { AbstractPageComponent, BasePageComponent, NoResultComponent } from '@spike/scaffolds';
import { Button } from "primeng/button";
import { PaginatorModule } from "primeng/paginator";
import { CommonModule } from '@angular/common';
import { PagedResponse, ResourceApiService } from '@spike/core';
import { EtiquetteStoreService } from '../../../configuration/services/etiquette-store.service';
import { OrderPageComponent } from "../order-page/order-page";
import { OrdersFiltersFormComponent } from "../../forms/orders-filters-form/orders-filters-form";
import { OrdersTableComponent } from "../../components/orders-table/orders-table";
import { PaginationModel } from 'src/app/features/shared/models/pagination-model';
import { SortingModel } from 'src/app/features/shared/models/sorting.model';
import { VOrder } from '../../models/vorder.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { Order } from '../../models/order.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-orders-page',
  providers:[],
  imports: [BasePageComponent, CommonModule, NoResultComponent, Button, PaginatorModule, OrderPageComponent, OrdersFiltersFormComponent, OrdersTableComponent],
  templateUrl: './orders-page.html',
  
})
export class OrdersPageComponent extends AbstractPageComponent{
    // Inject
  private readonly resourceApi = inject(ResourceApiService);
  private readonly etiquetteStore = inject(EtiquetteStoreService);

  //local state
  public readonly pagination = signal<PaginationModel>({ rows: 25, currentPage: 0, first: 0, rowsPerPageOptions: [25, 50, 100] });
  public readonly searchFilter = signal<any>({});
  public readonly sorting = signal<SortingModel>({ orderByClause: 'expire_date', orderDirection: 'desc' });
  
  public resourceFilter = computed(()=>{
    const searchFilter = this.searchFilter()
    const pagination = this.pagination();
    const sorting = this.sorting();

    const filter = {...searchFilter}
    return { filter: filter,  likable: true, currentPage: pagination.currentPage, maxResultPerPage: pagination.rows, orderByClause: sorting.orderByClause, orderDirection: sorting.orderDirection };

  })

   //resource
  public readonly entityList = this.resourceApi.call<PagedResponse<VOrder>>(signal(EntityApiEnum.ORDER), signal('searchView' ), this.resourceFilter);
  public selectedItem = signal<Order|undefined>(undefined);
  
  public isDetailVisible = signal<boolean>(false);
  

  public onPageChange(event: any): void {
    this.pagination.update(p => ({...p, rows: event.rows || p.rows, first: event.first || 0, currentPage: event.page || 0}));
  }

  public onInsert() {
    this.onSelect();
  }

  public onSelect(order?: VOrder) {
    this.selectedItem.set(order);
    this.isDetailVisible.set(true);
  }


  public onSave(): void{
    this.entityList.reload();
  }

}